/**
 * To create a new A/B test, add new object with A/B test details to TEST_EXPERIMENTS
 * with 'test', 'experimentName', and 'isActive' properties. Setting 'isActive' to false
 * will prevent requesting experiment data from the server for that particular test.
 *
 * export const TEST_EXPERIMENTS = {
 *  NAME_OF_TEST: {
 *      test: 'spiffyTest101.ZRM-100',      // Formatted as: [TEST_NAME].[JIRA_TICKET]
 *      experimentName: 'spiffyTest101',    // Must match first part of test property above, before '.'
 *      isActive: true                      // (true || false) Sometimes we leave old experiment info behind for reference.
 *  }
 * }
 *
 * Ensure that the test string ('spiffyTest101.ZRM-100') has been added
 * into the A/B Test Experiments dashboard and that the experiment is running:
 * https://hotpads.com/hotpads-api/internal/tool/ab/experimentDashboard
 */

export const TEST_EXPERIMENTS = {};
